import moment from 'moment';
import { FlowType, MacroFlowType } from '../../../../../store/models/flow-type';
import { flowTypeUtil } from '../../../../functions/verifications.functions';
import { AttributeValues } from './base-attribute-values';

export class BroadBandAttributeValues extends AttributeValues {
    attributesMapping(): void {
        super.attributesMapping();

        if (flowTypeUtil(this.state.orderEntryV2.flowType).equalTo(FlowType.VariazioneCommercialeBroadband)) {
            this.attr['egl_broadbandvulnerability__c'] =
                this.currentProduct?.configurations?.vulnerabilityDisabledBroadBand;
        }
        this.attr['egl_bb_termination_request_date__c'] = this.currentProduct?.cancellationRequestDate
            ? moment(this.currentProduct.cancellationRequestDate).format('YYYY-MM-DD')
            : null;
        this.attr['egl_bb_termination_request_reason__c'] = this.currentProduct?.terminationReason;
        this.attr['egl_bb_termination_description_request__c'] = this.currentProduct?.terminationReasonDescription;

        if (
            flowTypeUtil(this.state.orderEntryV2.flowType).inMacroFlowTypes(MacroFlowType.BroadBand) ||
            flowTypeUtil(this.state.orderEntryV2.flowType).equalTo(FlowType.BroadBandCambioProdotto)
        ) {
            this.attr['egl_bb_modemsupply__c'] = this.currentProduct?.configurations?.modemSupply;
            this.attr['egl_related_contract_code__c'] = this.currentProduct?.configurations?.relatedContractCode;
            this.attr['egl_category_customer__c'] = this.currentProduct?.configurations?.categoryCustomer;
            this.attr['egl_bb_OLO__c'] = this.currentProduct?.broadbandConfig?.oloDonating;
            this.attr['egl_cluster__c'] =
                this.currentProduct?.configurations?.cluster ||
                this.coverageVerificationService?.coverageSummarySelected?.cluster;
            this.attr['egl_coverage_state__c'] =
                this.currentProduct?.configurations?.coverageState ||
                this.coverageVerificationService?.coverageSummarySelected?.coverageState;
            this.attr['egl_bb_technology__c'] =
                this.currentProduct?.configurations?.technology ||
                this.coverageVerificationService?.coverageSummarySelected?.technology;
            this.attr['egl_bb_wholesaler__c'] =
                this.currentProduct?.configurations?.wholesaler ||
                this.coverageVerificationService?.coverageSummarySelected?.provider;
            this.attr['egl_bb_speedprofile__c'] =
                this.currentProduct?.configurations?.speedprofile ||
                this.coverageVerificationService?.coverageSummarySelected?.profile;
            this.attr['egl_bb_voice__c'] =
                this.currentProduct?.configurations?.voice ||
                this.coverageVerificationService?.coverageSummarySelected?.serviceSpecification;
            this.attr['egl_bb_migrationcodeolo__c'] = this.currentProduct?.broadbandConfig?.migrationCode;
            this.attr['egl_bb_line_number__c'] = this.currentProduct?.broadbandConfig?.lineTelephone;
            this.attr['egl_neta_productClass__c'] = this.currentProduct?.configurations?.productClass;
            this.attr['egl_bb_DAC__c'] = moment(this.currentProduct?.plannedDeliveryDate).format('YYYY-MM-DD');
        }
    }
}
